<template>
    <div class="overflow-wrapper">
        <div v-if="showPodani" class="overflow-container">
            <ShowPodani
                :isManager="isManager"
                :isInvestor="isInvestor"
                :idPodani="idPodani"
                @hidePodani="hidePodani"
                @gotoNewPodani="newPodani"
                @editPodani="editPodani"
            />

            <div v-for="(dp, i) in dodatecnaPodani" :key="i">
                <hr style="margin-top: 20px;" />
                <ShowPodani
                    :isManager="isManager"
                    :isInvestor="isInvestor"
                    :idPodani="dp"
                    @editPodani="editPodani"
                />
            </div>
        </div>

        <div v-if="showEdit" class="overflow-container">
            <EditPodani
                :itemId="idPodani"
                :isEditor="isEditor"
                :isAdmin="isAdmin"
                :idUser="idUser"
                @backToPodani="gotoPodani"
                @backToSeznamPodani="gotoSeznamPodani"
            />
        </div>

        <div v-if="!this.showPodani && !this.showEdit" class="overflow-container">
            <div class="cols">
                <div>
                    <span style="margin-right: 5px;">Zakázka:</span>
                    <select v-model="idz" style="width: 400px;">
                        <option :value="-1">&lt; vyberte zakázku &gt;</option>
                        <option v-for="(z, i) in sortedZakazka" :key="i" :value="z.id">{{ z.cisloZakazky + ' - ' + z.nazev }}</option>
                    </select>
                </div>
            </div>

            <div class="cols" style="margin-top: 30px; gap: 5px;">
                <button v-if="!this.isProjektant" :class="'button-small' + (this.showStanoviska ? ' button-inverse' : '')" @click="gotoPodaniList">Podání</button>
                <button :class="'button-small' + (!this.showStanoviska ? ' button-inverse' : '')" @click="gotoStanoviskaList">Stanoviska</button>
                <button v-if="!this.isInvestor" class="button-small" style="margin-left: 30px;" @click="exportData(false)">Export</button>
                <button v-if="!this.isInvestor" class="button-small" @click="exportData(true)">Export s přílohami</button>
            </div>

            <div style="margin-top: 0px;">
                <table>
                    <thead>
                        <tr>
                            <th v-for="(v, k) in headers" :key="k" @click="sort(k)">{{ v }}</th>
                            <th v-if="this.isAdmin && !this.showStanoviska"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(row, i) in sortedRows" :key="i" >
                            <td
                                v-for="(header, j) in headerKeys"
                                :key="j"
                                :class="getCellClass(header, row)"
                                :style="getCellStyle(header, row)"
                                v-on="header !== 'prilohaStanoviska' ? { click: () => gotoPodani(row.idNadrazenePodani === -1 ? row.id : row.idNadrazenePodani) } : {}"
                            >
                                <span v-if="header === 'predmet' && row.idNadrazenePodani !== -1" style="display: inline-block; width: 20px;">&nbsp;</span>

                                <span v-if="header === 'datumOdeslani'">{{ formatDate(row[header]) }}</span>
                                <span v-else-if="header === 'lhutaKVyrizeni'">{{ formatDate(row[header]) }}</span>
                                <span v-else-if="header === 'datumVydaniStanoviska'">{{ formatDate(row[header]) }}</span>
                                <span v-else-if="header === 'datumPrijetiStanoviska'">{{ formatDate(row[header]) }}</span>
                                <span v-else-if="header === 'platnostStanoviska'">{{ !row.platnostNeomezene ? formatDate(row[header]) : 'Neomezeně' }}</span>
                                <span v-else-if="header === 'prilohaStanoviska'"><span v-html="prilohaStanoviska(row)"></span></span>
                                <span v-else>{{ row[header] }}</span>
                            </td>

                            <td v-if="this.isAdmin && !this.showStanoviska">
                                <button class="button-small" @click="smazatPodani(row.id)">Smazat</button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    import api from '@/api/api.js'
    import dayjs from 'dayjs'
    import ShowPodani from './ShowPodani.vue'
    import EditPodani from './EditPodani.vue'

    export default {
        name: 'Podani',
        props: ['isEditor', 'isAdmin', 'isManager', 'isInvestor', 'isProjektant', 'idUser', 'idZakazka', 'showStanoviska'],
        components: {
            ShowPodani,
            EditPodani
        },
        data() {
            return {
                headers: {},
                rows: [],
                currentSort: '',
                currentSortDir: 'asc',
                idz: -1,
                zakazka: [],
                showPodani: false,
                showEdit: false,
                idPodani: -1,
                dodatecnaPodani: []
            }
        },
        computed: {
            headerKeys() {
                return Object.keys(this.headers)
            },
            sortedRows() {
                if (this.currentSort === '')
                    return this.rows
                return this.rows.slice().sort(
                    (a, b) => this.currentSortDir === 'desc' 
                        ? (b[this.currentSort] === null || b[this.currentSort] === undefined ? -1 : (a[this.currentSort] === null || a[this.currentSort] === undefined ? 1 : b[this.currentSort].localeCompare(a[this.currentSort], 'cz'))) 
                        : (a[this.currentSort] === null || a[this.currentSort] === undefined ? -1 : (b[this.currentSort] === null || b[this.currentSort] === undefined ? 1 : a[this.currentSort].localeCompare(b[this.currentSort], 'cz'))))
            },
            sortedZakazka() {
                return this.zakazka
                    .filter(z => z.stav == 0 || z.stav == 1)
                    .slice()
                    .sort((a, b) => (a.cisloZakazky + ':' + a.nazev).localeCompare((b.cisloZakazky + ':' + b.nazev), 'cz'))
            }
        },
        watch: {
            idz(newVal, oldVal) {
                if (oldVal !== newVal) {
                    this.page = 1
                    this.updateTable()
                }
            },
            showStanoviska(newVal, oldVal) {
                if (oldVal !== newVal) {
                    this.showEdit = false
                    this.showPodani = false
                    this.updateTable()
                }
            }
        },
        methods: {
            load() {
                this.$progress.start()
                if (this.isEditor || this.isAdmin || this.isManager) {
                    api.getZakazka()
                    .then(response => {
                        this.zakazka = response.data
                    })
                    .catch(error => { 
                        console.log('Error: ', error)
                    })
                }
                else if (this.isProjektant) {
                    api.getZakazkaForProjektant(this.idUser)
                    .then(response => {
                        this.zakazka = response.data
                    })
                    .catch(error => { 
                        console.log('Error: ', error)
                    })
                }
                else {
                    api.getZakazkaForUser(this.idUser)
                    .then(response => {
                        this.zakazka = response.data
                    })
                    .catch(error => { 
                        console.log('Error: ', error)
                    })
                }
                this.$progress.finish()
            },
            updateTable() {
                if (this.showStanoviska) {
                    if (this.idz != -1)
                        this.headers = { "predmet": "Předmět", "instituce": "Instituce", "pracoviste": "Pracoviště", "datumVydaniStanoviska": "Vydáno", "datumPrijetiStanoviska": "Přijato", 
                            "cisloJednaciVydani": "Číslo jednací odesílatele", "druhStanoviska": "Druh", "platnostStanoviska": "Platnost", "prilohaStanoviska": "Příloha stanoviska", 
                            "status": "Stav" }
                    else
                        this.headers = { "predmet": "Předmět", "zakazka": "Zakázka", "instituce": "Instituce", "pracoviste": "Pracoviště", "datumVydaniStanoviska": "Vydáno", "datumPrijetiStanoviska": "Přijato", 
                            "cisloJednaciVydani": "Číslo jednací odesílatele", "druhStanoviska": "Druh", "platnostStanoviska": "Platnost", "prilohaStanoviska": "Příloha stanoviska", 
                            "status": "Stav" }
                }
                else {
                    if (this.idz != -1)
                        this.headers = { "status": "Stav", "predmet": "Předmět", "instituce": "Instituce", "pracoviste": "Pracoviště", "odpovednaOsoba": "Odpovědná osoba", "druhPodani": "Druh",
                            "datumOdeslani": "Datum odeslání", "lhutaKVyrizeni": "Lhůta k vyřízení" }
                    else
                        this.headers = { "status": "Stav", "predmet": "Předmět", "zakazka": "Zakázka", "instituce": "Instituce", "pracoviste": "Pracoviště", "odpovednaOsoba": "Odpovědná osoba", "druhPodani": "Druh",
                            "datumOdeslani": "Datum odeslání", "lhutaKVyrizeni": "Lhůta k vyřízení" }
                }

                this.$progress.start()
                if (this.isEditor || this.isAdmin || this.isManager) {
                    api.getPodaniForZakazka(this.idz)
                    .then(response => {
                        this.rows = response.data
                    })
                    .catch(error => {
                        console.log('Error: ', error)
                    })
                }
                else if (this.isProjektant) {
                    api.getPodaniForProjektant(this.idUser, this.idz)
                    .then(response => {
                        this.rows = response.data
                    })
                    .catch(error => {
                        console.log('Error: ', error)
                    })
                }
                else {
                    api.getPodaniForUser(this.idUser, this.idz)
                    .then(response => {
                        this.rows = response.data
                    })
                    .catch(error => {
                        console.log('Error: ', error)
                    })
                }
                this.$progress.finish()
            },
            formatDate(date) {
                return date !== null ? dayjs(date).format('D.M.YYYY') : ''
            },
            gotoPodani(id) {
                this.idPodani = id
                this.showEdit = false
                this.showPodani = true

                api.getDodatecnaPodani(id)
                .then(response => {
                    this.dodatecnaPodani = response.data
                })
                .catch(error => {
                    console.log('Error: ', error)
                })
            },
            gotoSeznamPodani() {
                this.idPodani = -1
                this.showEdit = false
                this.showPodani = false
                this.dodatecnaPodani = []
                this.updateTable()
            },
            hidePodani() {
                this.showPodani = false
                this.dodatecnaPodani = []
                this.updateTable()
            },
            newPodani(idzakazka, idpodani) {
                this.$emit('gotoNewPodani', idzakazka, idpodani)
            },
            editPodani(id) {
                this.showPodani = false
                this.idPodani = id
                this.showEdit = true
            },
            gotoPodaniList() {
                this.page = 1
                this.$emit('gotoPodani', this.idz)
            },
            gotoStanoviskaList() {
                this.page = 1
                this.$emit('gotoStanoviska', this.idz)
            },
            prilohaStanoviska(row) {
                let stan = row.soubory.filter(s => s.typ === 1)
                let res = ''
                for (let i = 0; i < stan.length; i++)
                {
                    if (res.length > 0)
                        res = res + '<br />'
                    res = res + '<a target="_blank" href="' + process.env.VUE_APP_API_URL + '/Podani/download?id=' + row.soubory[i].id + '">' + row.soubory[i].nazev + '</a>'
                }
                return res

                // let index = row.soubory.findIndex(s => s.typ === 1)
                // return index !== -1 ? '<a target="_blank" href="' + process.env.VUE_APP_API_URL + '/Podani/download?id=' + row.soubory[index].id + '">' + row.soubory[index].nazev + '</a>' : ''
            },
            exportData(attachements) {
                if (this.isEditor || this.isAdmin || this.isManager) {
                    if (this.showStanoviska)
                        window.open(process.env.VUE_APP_API_URL + '/Export/stanoviska?uid=-1&pid=-1&zid=' + this.idz + '&att=' + (attachements ? '1' : '0'))
                    else
                        window.open(process.env.VUE_APP_API_URL + '/Export/podani?uid=-1&zid=' + this.idz + '&att=' + (attachements ? '1' : '0'))
                }
                else if (this.isProjektant) {
                    if (this.showStanoviska)
                        window.open(process.env.VUE_APP_API_URL + '/Export/stanoviska?uid=-1&pid=' + this.idUser + '&zid=' + this.idz + '&att=' + (attachements ? '1' : '0'))
                }
                else {
                    if (this.showStanoviska)
                        window.open(process.env.VUE_APP_API_URL + '/Export/stanoviska?uid=' + this.idUser + '&pid=-1&zid=' + this.idz + '&att=' + (attachements ? '1' : '0'))
                    else
                        window.open(process.env.VUE_APP_API_URL + '/Export/podani?uid=' + this.idUser + '&zid=' + this.idz + '&att=' + (attachements ? '1' : '0'))
                }
            },
            getCellStyle(header, row) {
                switch (header) {
                    case 'status':
                        return 'background-color: ' + row.gRepre
                    default:
                        return ''
                }
            },
            getCellClass(header, row) {
                switch (header) {
                    case 'lhutaKVyrizeni':
                        if (row.lhutaKVyrizeni != null && row.datumVydaniStanoviska == null) {
                            let diff = dayjs(row.lhutaKVyrizeni).diff(dayjs(), 'day')
                            return diff <= 5 ? (diff <= 0 ? 'redWarning' : 'yellowWarning') : ''
                        }
                        else
                            return ''
                    case 'platnostStanoviska':
                        if (row.platnostStanoviska != null && !row.platnostNeomezene) {
                            let diff = dayjs(row.platnostStanoviska).diff(dayjs(), 'day')
                            return diff <= 14 ? (diff <= 0 ? 'redWarning' : 'yellowWarning') : ''
                        }
                        else
                            return ''
                    default:
                        return ''
                }
            },
            sort(s) {
                if (s === this.currentSort) {
                    this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc'
                }
                else {
                    this.currentSort = s
                    this.currentSortDir = 'asc'
                }
            },
            async smazatPodani(id) {
                if (confirm('VAROVÁNÍ! Tuto akci nelze vzít zpátky. Opravdu chcete smazat toto podání a k němu podřízené položky?'))
                {
                    this.$progress.start()
                    await api.deletePodani(id)
                    this.$progress.finish()

                    this.updateTable()
                }
            }
        },
        created() {
            this.load()
            this.idz = this.idZakazka
            this.updateTable()
        }
    }
</script>